import {DesignerVersion} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignState';
import {IMigration} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/DesignMigrationController';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';

const MIGRATED_VERSION:DesignerVersion = 23;

export const migration_22_23:IMigration = {
    from: MIGRATED_VERSION - 1,
    to: MIGRATED_VERSION,
    migrate: (designState:any) =>
    {
        Assert.yes(designState.designerVersion === MIGRATED_VERSION - 1);

        console.log(`migration ${MIGRATED_VERSION - 1}->${MIGRATED_VERSION} designState`, designState);

        if( designState.spreadsheets && designState.spreadsheets.workbooks )
        {
            Object.values(designState.spreadsheets.workbooks).forEach((workbook:any) =>
            {
                workbook.view.meshStates = Object.values(workbook.view.meshStates).reduce((meshStates, meshState) =>
                {
                    const sheetId = (meshState as any).sheetId;

                    if( workbook.runtime.sheets.find((sheet:any) => sheet.id === sheetId) )
                    {
                        if( (meshState as any).isGridlinesVisible === undefined )
                            (meshState as any).isGridlinesVisible = true;

                        meshStates[sheetId] = meshState;
                    }

                    return meshStates;
                }, {});
            });
        }

        designState.designerVersion = MIGRATED_VERSION;

        return designState;
    }
};
